import { msg } from '@lingui/core/macro';

export const t = {
    transactionListFooter: {
        info: msg({
            id: 'span.TransactionListFooter.info',
            comment:
                'Info message shown beneath podlet showing that you have a new offer on an ad on the front page',
            message: `Finn dine handler på torget under Min FINN`,
        }),
    },
    adImage: {
        alt: msg({
            id: 'img.AdImage.alt',
            comment: 'Alt text for ad image',
            message: `Annonsebilde`,
        }),
        defaultImgAlt: msg({
            id: 'img.DefaultAdImage.alt',
            comment: 'Alt text for default ad image',
            message: `FINN standard annonsebilde illustrert med en minimalistisk illustrasjon av fjell og skyer i blåtoner`,
        }),
    },
};
